// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import Button from 'components/atoms/Button'

const StatusDesc = styled.pre`
  margin-top: ${spacing.small_2}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
  text-align: center;
  line-height: 1.454;
  white-space: pre-wrap;
`
const LabelHeader = styled.p`
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  text-align: center;

  &:not(:first-of-type) {
    margin-top: ${spacing.small}px;
  }
`
const ButtonWrapper = styled.div`
  margin-top: ${spacing.medium}px;
`

type PropTypes = {
  dayOfTerm: number | string,
  dueDate: string | Date,
  canBeReview: boolean,
  onClickPostReview: Function,
}

export default function ReservationTermBlock(props: PropTypes) {
  return (
    <Fragment>
      {props.canBeReview && (
        <LabelHeader>
          {i18n.t('page.dashboard.inbox.suggestReview')}
        </LabelHeader>
      )}
      <LabelHeader>
        {i18n.t('page.dashboard.inbox.term')}
        {props.dayOfTerm}
        {i18n.t('page.shared.unit.day')}（
        {moment(props.dueDate).format(i18n.t('page.shared.dateFormat3'))}
        {i18n.t('page.shared.until')}）
      </LabelHeader>
      {!props.canBeReview ? (
        <StatusDesc>{i18n.t('page.dashboard.inbox.termDesc')}</StatusDesc>
      ) : (
        <Fragment>
          <StatusDesc>
            {i18n.t('page.dashboard.inbox.suggestReviewDesc')}
          </StatusDesc>
          <ButtonWrapper>
            <Button
              tag="anchor"
              buttonType="medium"
              colorType="blue"
              fullWidthSp
              href="#"
              onClick={props.onClickPostReview}
            >
              {i18n.t('page.dashboard.inbox.postReview')}
            </Button>
          </ButtonWrapper>
        </Fragment>
      )}
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationTermBlock/index.jsx